import { toast } from "react-toastify";

export const errorFunc = (msg) => {
  if (msg) {
    return toast.error(`${msg}`);
  }
};
